export default {
    'OPERACION_TUPA': (state, mutation) => {
        state.operacion = mutation.oper
        state.tupa = mutation.tupa
    }
}